import { render } from "./Faq.vue?vue&type=template&id=2104ca49&scoped=true&ts=true"
import script from "./Faq.vue?vue&type=script&lang=ts"
export * from "./Faq.vue?vue&type=script&lang=ts"

import "./Faq.vue?vue&type=style&index=0&id=2104ca49&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2104ca49"]])

export default __exports__